import { render, staticRenderFns } from "./Parsers.vue?vue&type=template&id=adc470b8&scoped=true&"
import script from "./Parsers.vue?vue&type=script&lang=js&"
export * from "./Parsers.vue?vue&type=script&lang=js&"
import style0 from "./Parsers.vue?vue&type=style&index=0&id=adc470b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc470b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
